import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { getClubPrice } from "../../utils/clubPrice";
import ColorsView from "../common/ProductCard/ColorsView";
import RatingView from "../common/ProductCard/Rating";
import CardPricing from "../common/ProductCard/Pricing";
import { useSelector } from "react-redux";
import { LOGGEDIN } from "../../constants/auth";

const ListCards = ({ product, isAuthenticated }) => {
  const [productData, setProductData] = useState(product);
  const [clubPrice, setClubPrice] = useState(null);
  const { authState } = useSelector((state) => state.auth);

  useEffect(() => {
    setProductData(product);
    setClubPrice(getClubPrice(product));
  }, [product]);

  return (
    <Link
      to={`/products/${product.handle}`}
      className="max-w-full w-full  pl-0 md:pl-5 pb-[10px] md:pb-5 grow shrink-0 box-border"
    >
      <div className="flex w-full h-full bg-[#f2f2f2] rounded-[10px] overflow-hidden flex-row text-left border-inherit">
        {/* Image Container */}
        <div className="flex flex-1 w-2/5 md:w-[28%] no-underline text-left cursor-pointer border-inherit">
          <div className="relative block w-full overflow-hidden border-inherit">
            <div className="relative block bg-transparent w-full h-full md:pb-[100%] overflow-hidden border-inherit">
              {product?.media[0]?.preview?.image?.gatsbyImageData && (
                <div className="absolute block top-0 left-0 max-w-full w-full h-full text-left border-inherit">
                  <GatsbyImage
                    loading="lazy"
                    image={product?.media[0].preview.image?.gatsbyImageData}
                    alt={product?.media[0].preview.image?.altText}
                    className="relative w-full h-full object-cover object-center opacity-100 hover:opacity-0 transition-all duration-[400ms]"
                  />
                </div>
              )}
              {product?.media[1]?.preview?.image?.gatsbyImageData && (
                <div className="absolute block top-0 left-0 max-w-full w-full h-full text-left border-inherit">
                  <GatsbyImage
                    loading="lazy"
                    image={product?.media[1].preview.image?.gatsbyImageData}
                    alt={product?.media[1].preview.image?.altText}
                    className="relative w-full h-full object-cover object-center opacity-0 hover:opacity-100 transition-all duration-[400ms]"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Details Container */}
        <div className="relative max-w-[60%] md:max-w-[80%] flex items-center w-full h-full py-5 px-3 sm:px-[30px] overflow-hidden border-inherit">
          {" "}
          <div className="flex flex-row flex-wrap w-full items-center text-left border-inherit">
            <h5 className="text-lg font-bold w-full mb-[10px] tracking-[0.4px] leading-7 text-black">
              {product.title}
            </h5>
            {/* Pricing and Colors */}
            <div className="w-full md:w-3/5 flex flex-col justify-between items-start border-inherit">
              {/* Price */}
              <div className="font-semibold text-xs transition-all duration-300 ease-linear group-hover:opacity-100 group-hover:md:opacity-0">
                {!!product.reviewsCount?.value && (
                  <RatingView
                    reviewCount={product.reviewsCount}
                    reviewAverage={product.reviewsAverage}
                  />
                )}
                <div className="flex flex-wrap w-full">
                  <CardPricing
                    clubPrice={clubPrice}
                    variant={productData?.variants[0]}
                    isAuthenticated={authState === LOGGEDIN}
                  />
                  {product?.options?.find(
                    (option) =>
                      option.name === "Color" || option.name === "Colour"
                  )?.values?.length > 1 && (
                    <ColorsView url={`/products/${product?.handle}`} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ListCards;
